import { getProject } from 'common/api/v1/projects';

import {
    FETCH_PROJECT,
    FETCH_PROJECT_FAILURE,
    FETCH_PROJECT_SUCCESS,
} from '../actionTypes';
import { projectActions } from '../reducer';

export default (projectId) => (dispatch) => {
    dispatch(projectActions[FETCH_PROJECT]());

    getProject(projectId)
        .then((response) =>
            dispatch(projectActions[FETCH_PROJECT_SUCCESS](response.data.data)),
        )
        .catch((error) =>
            dispatch(
                projectActions[FETCH_PROJECT_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
